var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtocol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6875 17V14.3125H14.3125V17H27.6875ZM27.6875 22.3125V19.6875H14.3125V22.3125H27.6875ZM23.6875 27.6875V25H14.3125V27.6875H23.6875ZM21.9375 9.375C21.6875 9.125 21.375 9 21 9C20.625 9 20.3125 9.125 20.0625 9.375C19.8125 9.625 19.6875 9.9375 19.6875 10.3125C19.6875 10.6875 19.8125 11.0208 20.0625 11.3125C20.3125 11.5625 20.625 11.6875 21 11.6875C21.375 11.6875 21.6875 11.5625 21.9375 11.3125C22.1875 11.0208 22.3125 10.6875 22.3125 10.3125C22.3125 9.9375 22.1875 9.625 21.9375 9.375ZM30.3125 9C31.0208 9 31.6458 9.27083 32.1875 9.8125C32.7292 10.3542 33 10.9792 33 11.6875V30.3125C33 31.0208 32.7292 31.6458 32.1875 32.1875C31.6458 32.7292 31.0208 33 30.3125 33H11.6875C10.9792 33 10.3542 32.7292 9.8125 32.1875C9.27083 31.6458 9 31.0208 9 30.3125V11.6875C9 10.9792 9.27083 10.3542 9.8125 9.8125C10.3542 9.27083 10.9792 9 11.6875 9H17.25C17.5417 8.20833 18.0208 7.5625 18.6875 7.0625C19.3542 6.5625 20.125 6.3125 21 6.3125C21.875 6.3125 22.6458 6.5625 23.3125 7.0625C23.9792 7.5625 24.4583 8.20833 24.75 9H30.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.09b59be8d7a2a041c7f828bb5c71270d.svg";
export { ForwardRef as ReactComponent };